import axios from 'axios'
import React, { useEffect, useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import dateFormat from 'dateformat'
import { comma } from './Func.js'
import Nav from './Nav'

function Commission() {
    const address = useSelector((state) => state.address.value)
    const [isReferralData, setReferralData] = useState([])
    const [isSponsorData, setSponsorData] = useState([])
    const [isMatchingData, setMatchingData] = useState([])
    const [date, setDate] = useState()

    const referralArr = []
    const getReferralPerformance = useCallback(async () => {
        axios
            .post('api/getReferralPerformance', {
                address: address,
            })
            .then((res) => {
                res.data.forEach(function (element) {
                    referralArr.push(element)
                })
                setReferralData(referralArr)
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                }
            })
    }, [setReferralData, address])

    const sponsorArr = []
    const getSponsorPerformance = useCallback(async () => {
        axios
            .post('api/getSponsorPerformance', {
                address: address,
            })
            .then((res) => {
                res.data.forEach(function (element) {
                    sponsorArr.push(element)
                })
                setSponsorData(sponsorArr)
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                }
            })
    }, [setSponsorData, address])

    const matchingArr = []
    const getMatchingPerformance = useCallback(async () => {
        axios
            .post('api/getMatchingPerformance', {
                address: address,
            })
            .then((res) => {
                res.data.forEach(function (element) {
                    matchingArr.push(element)
                })
                setMatchingData(matchingArr)
            })
            .catch((err) => {
                if (err.response) {
                    console.log(err.response)
                }
            })
    }, [setMatchingData, address])

    useEffect(() => {
        getReferralPerformance()
        getSponsorPerformance()
        getMatchingPerformance()
    }, [getReferralPerformance, getSponsorPerformance, getMatchingPerformance])

    useEffect(() => {
        let now = new Date()
        let yesterday = new Date(now.setDate(now.getDate() - 1))
        setDate(dateFormat(yesterday, 'yyyy-m-d'))
    }, [])

    const referralRows = (rows) => {
        if (rows !== '') {
            return rows.map((row) => (
                <tr>
                    <td width={'50%'}>{row.from}</td>
                    <td width={'50%'}>{comma(row.profit)}</td>
                </tr>
            ))
        } else {
            return (
                <tr>
                    <td colSpan="3">Data is empty!</td>
                </tr>
            )
        }
    }

    const sponsorRows = (rows) => {
        if (rows !== '') {
            return rows.map((row) => (
                <tr>
                    <td width={'20%'}>{comma(row.before_left)}</td>
                    <td width={'20%'}>{comma(row.before_right)}</td>
                    <td width={'20%'}>{comma(row.left)}</td>
                    <td width={'20%'}>{comma(row.right)}</td>
                    <td width={'20%'}>{comma(row.profit)}</td>
                </tr>
            ))
        } else {
            return (
                <tr>
                    <td colSpan="5">Data is empty!</td>
                </tr>
            )
        }
    }

    const matchingRows = (rows) => {
        if (rows !== '') {
            return rows.map((row) => (
                <tr>
                    <td width={'25%'}>{row.from}</td>
                    <td width={'25%'}>{row.depth}</td>
                    <td width={'25%'}>{comma(row.sponsor_profit)}</td>
                    <td width={'25%'}>{comma(row.matching_profit)}</td>
                </tr>
            ))
        } else {
            return (
                <tr>
                    <td colSpan="4">Data is empty!</td>
                </tr>
            )
        }
    }

    function Referral() {
        return (
            <div className="deposit-history history-wrap">
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>FromChild</th>
                            <th style={{ color: '#d8bd99' }}>Commission</th>
                        </tr>
                    </thead>
                    <tbody>{referralRows(isReferralData)}</tbody>
                </table>
            </div>
        )
    }
    function Sponsor() {
        return (
            <div className="deposit-history history-wrap">
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>Ex-Left</th>
                            <th>Ex-Right</th>
                            <th>Left</th>
                            <th>Right</th>
                            <th style={{ color: '#d8bd99' }}>Commission</th>
                        </tr>
                    </thead>
                    <tbody>{sponsorRows(isSponsorData)}</tbody>
                </table>
            </div>
        )
    }
    function Matching() {
        return (
            <div className="deposit-history history-wrap">
                <table className="history-table">
                    <thead>
                        <tr>
                            <th>FromChild</th>
                            <th>Depth</th>
                            <th>SponCommission</th>
                            <th style={{ color: '#d8bd99' }}>Commission</th>
                        </tr>
                    </thead>
                    <tbody>{matchingRows(isMatchingData)}</tbody>
                </table>
            </div>
        )
    }

    return (
        <div className="sub-container">
            <div id="history" className="content">
                <p className="hisTitle" style={{ marginLeft: 0, marginBottom: 3 }}>
                    Commission
                </p>
                <p className="invest-date" style={{ marginLeft: 18, marginBottom: 0 }}>
                    {date}
                </p>
                <Tabs>
                    <TabList>
                        <Tab>Referral</Tab>
                        {/* <Tab>Sponsor</Tab>
                        <Tab>Matching</Tab> */}
                    </TabList>
                    <TabPanel>
                        <Referral />
                    </TabPanel>
                    <TabPanel>
                        <Sponsor />
                    </TabPanel>
                    <TabPanel>
                        <Matching />
                    </TabPanel>
                </Tabs>
            </div>
            <Nav />
        </div>
    )
}

export default Commission
